export const limits = {
  min: 0,
  max: 5000000,
  secs: 3,
};

export const VMS = {
  min: 0,
  max: 1500,
  default: 100,
};

export const values = {
  assumedEfficiencyImprovement: 33,
};

export const CurrentNumberOnPremHosts = {
  min: 0,
  max: 100,
  default: 15,
};

export const CurrentMonthtlyCloudBill = {
  min: 0,
  max: 100000,
  default: 25000,
};

export const CurrentCostOnPremHost = {
  min: 0,
  max: 100000,
  default: 25000,
};

export const AnnualGrowthRateOnPremVM = {
  min: 1,
  max: 100,
  default: 20,
};

export const AnnualGrowthRateCloudInstance = {
  min: 1,
  max: 100,
  default: 25,
};

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30TurboROI = '30AY5';
